export default "__VITE_ASSET__bf621aa3__"